import { DATE_FORMATS } from '@/shared/utils/date/date-formats';
import dayjs from 'dayjs';

export function formatCampaignPeriod(startDate: string, endDate?: string) {
  const startLabel = dayjs(startDate).format(DATE_FORMATS.base);
  if (!endDate) return `${startLabel} - Open ended`;
  return `${startLabel} - ${dayjs(endDate).format(DATE_FORMATS.base)}`;
}
